// The masjid's Hijri adjustment: a change is previewed on the calendar at once
// and only saved when the owner says so.
import React from "react";
import { Loader2 } from "lucide-react";

const MIN = -5;
const MAX = 5;
const signed = (n) => (n > 0 ? `+${n}` : String(n));

const StepButton = ({ onClick, disabled, label, children }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    aria-label={label}
    className="h-10 w-10 rounded-lg border border-gray-300 text-xl font-medium text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-40"
  >
    {children}
  </button>
);

export default function CalanderFilters({ variation, saved, onVariation, onSave, onReset, saving }) {
  const changed = saved !== null && variation !== saved;
  return (
    <div className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm">
      <p className="text-xs font-semibold uppercase tracking-wider text-gray-500">Hijri adjustment</p>
      <div className="mt-3 flex items-center gap-3">
        <StepButton onClick={() => onVariation(variation - 1)} disabled={saving || variation <= MIN} label="One day earlier">−</StepButton>
        <output aria-live="polite" className="min-w-[5.5rem] text-center">
          <span className="block text-2xl font-bold text-gray-900">{signed(variation)}</span>
          <span className="block text-xs text-gray-500">{Math.abs(variation) === 1 ? "day" : "days"}</span>
        </output>
        <StepButton onClick={() => onVariation(variation + 1)} disabled={saving || variation >= MAX} label="One day later">+</StepButton>
      </div>
      <p className="mt-3 text-sm text-gray-600">
        Moon sighting differs by country. If your community's Hijri dates are a day earlier or later, adjust them here.
        Your website and screens use the saved adjustment.
      </p>
      {changed ? (
        <div className="mt-3 flex flex-wrap items-center gap-2">
          <button
            type="button"
            onClick={onSave}
            disabled={saving}
            className="inline-flex items-center gap-2 rounded-lg bg-emerald-600 px-4 py-2 text-sm font-semibold text-white hover:bg-emerald-700 disabled:opacity-60"
          >
            {saving && <Loader2 className="h-4 w-4 animate-spin" />}
            {saving ? "Saving…" : `Save ${signed(variation)} day${Math.abs(variation) === 1 ? "" : "s"}`}
          </button>
          <button type="button" onClick={onReset} disabled={saving} className="rounded-lg px-3 py-2 text-sm text-gray-600 hover:bg-gray-100">
            Back to saved ({signed(saved)})
          </button>
        </div>
      ) : (
        saved !== null && <p className="mt-3 text-xs font-medium text-emerald-700">Saved</p>
      )}
    </div>
  );
}
